import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import EventDetails from 'components/UI/Event/EventDetails';

const EventDetailsStyled = withStyles(theme => ({
  root: {
    color: '#262326',
    '& .MuiTypography-h5': {
      color: theme.palette.primary.dark,
    }
  },
  left: {
    '& .MuiTypography-h4': {
      color: theme.palette.secondary.dark,
      fontWeight: 600
    },
    '& .MuiTypography-body1': {
      color: theme.palette.text.light
    },
    '& .MuiTypography-caption': {
      color: theme.palette.text.light
    }
  },
  itemThumb: {
    backgroundColor: '#f1ddfb',
    '&:before': {
      backgroundImage: 'none',
      backgroundColor: '#fff',
      backgroundSize: '100%',
      backgroundImage: 'url('+require('assets/images/event_details.png')+')'
    }
  },
  titleIcon: {
    borderColor: theme.palette.primary.main,
    backgroundColor: '#fff'
  }
}))(EventDetails)

class EventDetailsWrapper extends Component {
  render() {
    return (<EventDetailsStyled templateProps={{kind: 'fullWidth', maxWidth: 'auto'}} {...this.props}/>)
  }
}

export default EventDetailsWrapper;



// WEBPACK FOOTER //
// ./src/components/Event/EventDetails.jsx